import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {SearchFormValuesType} from "../types/SearchFormValuesType";

const RECENT_FILTERS_STORAGE_KEY = "rp_recent_search_filters";
export const MAX_RECENT_FILTERS = 5;
const DEFAULT_FILTERS_DISPLAY_LIMIT = 1;

export interface IRecentFilter {
    filters: Partial<ISearchFiltersFormValues>;
    search?: SearchFormValuesType["search"];
    timestamp: number;
}

const getRecentFilterKey = (item: IRecentFilter): string => JSON.stringify({filters: item.filters, search: item.search});

/**
 * Saves filters to localStorage. Keeps up to 5 most recent searches.
 * New search is prepended; duplicates (same filters + search) are removed, keeping the newest.
 */
export const saveRecentFilters = (formValues: SearchFormValuesType): void => {
    try {
        const cleanedFilters: Partial<ISearchFiltersFormValues> = {};

        if (hasRangeValue(formValues.price)) {
            cleanedFilters.price = formValues.price;
        }

        if (hasRangeValue(formValues.rooms)) {
            cleanedFilters.rooms = formValues.rooms;
        }

        if (hasRangeValue(formValues.area)) {
            cleanedFilters.area = formValues.area;
        }

        if (formValues.instalment && formValues.instalment !== "") {
            cleanedFilters.instalment = formValues.instalment;
        }

        if (Array.isArray(formValues.type) && formValues.type.length > 0) {
            cleanedFilters.type = formValues.type;
        }

        if (Array.isArray(formValues.construction_end_date) && formValues.construction_end_date.length > 0) {
            cleanedFilters.construction_end_date = formValues.construction_end_date;
        }

        const hasFilters = Object.keys(cleanedFilters).length > 0 || formValues.search;

        if (!hasFilters) {
            return;
        }

        const newFilter: IRecentFilter = {
            filters: cleanedFilters,
            search: formValues.search,
            timestamp: Date.now()
        };

        const existing = getStoredRecentFilters();
        const merged = [newFilter, ...existing].filter(
            (item, index, arr) => arr.findIndex((x) => getRecentFilterKey(x) === getRecentFilterKey(item)) === index
        );
        const toStore = merged.slice(0, MAX_RECENT_FILTERS);

        localStorage.setItem(RECENT_FILTERS_STORAGE_KEY, JSON.stringify(toStore));
    } catch (error) {
        console.error("Failed to save recent filters:", error);
    }
};

/**
 * Checks if range has values
 */
export const hasRangeValue = (range: {lower: string | number | ""; upper: string | number | ""} | undefined): boolean => {
    return !!range && (range.lower !== "" || range.upper !== "");
};

/**
 * Reads the full stored list from localStorage (up to 5 entries), newest first.
 * Used internally by saveRecentFilters to merge/dedup without losing background history.
 * Supports both legacy single-object and new array format.
 */
const getStoredRecentFilters = (): IRecentFilter[] => {
    if (typeof window === "undefined") {
        return [];
    }

    try {
        const stored = localStorage.getItem(RECENT_FILTERS_STORAGE_KEY);

        if (!stored) {
            return [];
        }

        const parsed = JSON.parse(stored) as IRecentFilter | IRecentFilter[];

        if (Array.isArray(parsed)) {
            return parsed;
        }

        return parsed.filters || parsed.search ? [parsed] : [];
    } catch (error) {
        console.error("Failed to get recent filters:", error);

        return [];
    }
};

/**
 * Gets the most recent filters from localStorage, newest first.
 * Defaults to the single most recent one (search dropdown display); pass
 * `MAX_RECENT_FILTERS` to get the full stored history (homepage personalization).
 */
export const getRecentFilters = (limit: number = DEFAULT_FILTERS_DISPLAY_LIMIT): IRecentFilter[] => {
    return getStoredRecentFilters().slice(0, limit);
};

/**
 * Gets the most recent filter (first from list). For backward compatibility.
 */
export const getRecentFilter = (): IRecentFilter | null => {
    const list = getRecentFilters();
    return list.length > 0 ? list[0] : null;
};
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {SearchFormValuesType} from "../types/SearchFormValuesType";

const RECENT_FILTERS_STORAGE_KEY = "rp_recent_search_filters";
export const MAX_RECENT_FILTERS = 5;
const DEFAULT_FILTERS_DISPLAY_LIMIT = 1;

export interface IRecentFilter {
    filters: Partial<ISearchFiltersFormValues>;
    search?: SearchFormValuesType["search"];
    timestamp: number;
}

const getRecentFilterKey = (item: IRecentFilter): string => JSON.stringify({filters: item.filters, search: item.search});

/**
 * Saves filters to localStorage. Keeps up to 5 most recent searches.
 * New search is prepended; duplicates (same filters + search) are removed, keeping the newest.
 */
export const saveRecentFilters = (formValues: SearchFormValuesType): void => {
    try {
        const cleanedFilters: Partial<ISearchFiltersFormValues> = {};

        if (hasRangeValue(formValues.price)) {
            cleanedFilters.price = formValues.price;
        }

        if (hasRangeValue(formValues.rooms)) {
            cleanedFilters.rooms = formValues.rooms;
        }

        if (hasRangeValue(formValues.area)) {
            cleanedFilters.area = formValues.area;
        }

        if (formValues.instalment && formValues.instalment !== "") {
            cleanedFilters.instalment = formValues.instalment;
        }

        if (Array.isArray(formValues.type) && formValues.type.length > 0) {
            cleanedFilters.type = formValues.type;
        }

        if (Array.isArray(formValues.construction_end_date) && formValues.construction_end_date.length > 0) {
            cleanedFilters.construction_end_date = formValues.construction_end_date;
        }

        const hasFilters = Object.keys(cleanedFilters).length > 0 || formValues.search;

        if (!hasFilters) {
            return;
        }

        const newFilter: IRecentFilter = {
            filters: cleanedFilters,
            search: formValues.search,
            timestamp: Date.now()
        };

        const existing = getStoredRecentFilters();
        const merged = [newFilter, ...existing].filter(
            (item, index, arr) => arr.findIndex((x) => getRecentFilterKey(x) === getRecentFilterKey(item)) === index
        );
        const toStore = merged.slice(0, MAX_RECENT_FILTERS);

        localStorage.setItem(RECENT_FILTERS_STORAGE_KEY, JSON.stringify(toStore));
    } catch (error) {
        console.error("Failed to save recent filters:", error);
    }
};

/**
 * Checks if range has values
 */
export const hasRangeValue = (range: {lower: string | number | ""; upper: string | number | ""} | undefined): boolean => {
    return !!range && (range.lower !== "" || range.upper !== "");
};

/**
 * Reads the full stored list from localStorage (up to 5 entries), newest first.
 * Used internally by saveRecentFilters to merge/dedup without losing background history.
 * Supports both legacy single-object and new array format.
 */
const getStoredRecentFilters = (): IRecentFilter[] => {
    if (typeof window === "undefined") {
        return [];
    }

    try {
        const stored = localStorage.getItem(RECENT_FILTERS_STORAGE_KEY);

        if (!stored) {
            return [];
        }

        const parsed = JSON.parse(stored) as IRecentFilter | IRecentFilter[];

        if (Array.isArray(parsed)) {
            return parsed;
        }

        return parsed.filters || parsed.search ? [parsed] : [];
    } catch (error) {
        console.error("Failed to get recent filters:", error);

        return [];
    }
};

/**
 * Gets the most recent filters from localStorage, newest first.
 * Defaults to the single most recent one (search dropdown display); pass
 * `MAX_RECENT_FILTERS` to get the full stored history (homepage personalization).
 */
export const getRecentFilters = (limit: number = DEFAULT_FILTERS_DISPLAY_LIMIT): IRecentFilter[] => {
    return getStoredRecentFilters().slice(0, limit);
};

/**
 * Gets the most recent filter (first from list). For backward compatibility.
 */
export const getRecentFilter = (): IRecentFilter | null => {
    const list = getRecentFilters();
    return list.length > 0 ? list[0] : null;
};
